var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistantIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58571 18.1001L0.470459 16.2234V15.2715H6.63855L5.58571 18.1001Z",
    fill: "#FD7DA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6472 7.27521L23.5293 4.08984L19.8168 19.912H7.88391L5.58569 18.1L8.54682 10.1447L11.6136 8.90533L15.6472 7.27521Z",
    fill: "#D2DCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1866 19.9114H7.88399L5.58563 18.0992L8.54657 10.1443L10.0054 9.55469C9.99081 9.7721 9.98375 9.99139 9.98375 10.2121C9.98375 14.7048 12.9946 18.5227 17.1866 19.9114Z",
    fill: "#93B2F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6471 7.27521L15.5992 7.29455L17.8257 11.2721L19.8429 19.8002L23.5292 4.08984L15.6471 7.27521Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8258 11.273L12.6177 10.7229L9.97363 5.93945L15.1817 6.48952L17.8258 11.273Z",
    fill: "#FD7DA0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58571 18.1001L0.470459 16.2234V15.2715H6.63855",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6472 7.27521L23.5293 4.08984L19.8168 19.912H7.88391L5.58569 18.1L8.54682 10.1447L11.6136 8.90533",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8258 11.273L12.6177 10.7229L9.97363 5.93945L15.1817 6.48952L17.8258 11.273Z",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0665,
    cy: 7.29676,
    r: 0.470588,
    fill: "#052A75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantIcon8);
export default __webpack_public_path__ + "static/media/assistant-icon-8.6ea44bcc6d9e353955bf2af18423c47a.svg";
export { ForwardRef as ReactComponent };